import React from "react"

import Header from "../header";
import Footer from "../footer";

import "../../styles/index.scss"

class Layout extends React.Component {
  render() {
    const {children, className} = this.props;

    return (
      <>
        <Header />
        <div className={className}>
          <main>{children}</main>
        </div>
        <Footer />
      </>
    )
  }
}

export default Layout
